<template>
  <!-- ========== COMMUNITY-WAND ========== -->
  <section class="k-sec alt reveal" id="community">
    <div class="k-head">
      <span class="k-eyebrow">Wer hier schreibt</span>
      <h2>Ein paar <span class="grad">von uns</span>.</h2>
      <p>Ganz unterschiedliche Menschen, ein gemeinsamer Nenner: Lust auf gute Gespräche.</p>
    </div>

    <div class="mq" role="list" aria-label="Mitglieder-Profile">
      <div class="mq-track">
        <!-- Reihe 1 -->
        <button type="button" class="pcard is-on" data-open-signup role="listitem" aria-label="Lena, 27 — kostenlos registrieren und schreiben">
          <span class="pav"><img :src="img('lena')" alt="" decoding="async" width="72" height="72"><span class="dot"></span></span>
          <span><span class="pnm">Lena, 27</span><span class="ptags"><span class="tag">Fotografie</span><span class="tag">Wandern</span></span></span>
        </button>
        <button type="button" class="pcard" data-open-signup role="listitem" aria-label="Jonas, 29 — kostenlos registrieren und schreiben">
          <span class="pav"><img :src="img('jonas')" alt="" decoding="async" width="72" height="72"><span class="dot"></span></span>
          <span><span class="pnm">Jonas, 29</span><span class="ptags"><span class="tag">Bouldern</span><span class="tag">Podcasts</span></span></span>
        </button>
        <button type="button" class="pcard is-on" data-open-signup role="listitem" aria-label="Carla, 34 — kostenlos registrieren und schreiben">
          <span class="pav"><img :src="img('carla')" alt="" decoding="async" width="72" height="72"><span class="dot"></span></span>
          <span><span class="pnm">Carla, 34</span><span class="ptags"><span class="tag">Yoga</span><span class="tag">Reisen</span></span></span>
        </button>
        <button type="button" class="pcard" data-open-signup role="listitem" aria-label="Anna, 54 — kostenlos registrieren und schreiben">
          <span class="pav"><img :src="img('anna')" alt="" decoding="async" width="72" height="72"></span>
          <span><span class="pnm">Anna, 54</span><span class="ptags"><span class="tag">Garten</span><span class="tag">Krimis</span></span></span>
        </button>
        <button type="button" class="pcard is-on" data-open-signup role="listitem" aria-label="Lukas, 27 — kostenlos registrieren und schreiben">
          <span class="pav"><img :src="img('lukas')" alt="" decoding="async" width="72" height="72"><span class="dot"></span></span>
          <span><span class="pnm">Lukas, 27</span><span class="ptags"><span class="tag">Klettern</span><span class="tag">Filmabende</span></span></span>
        </button>
        <button type="button" class="pcard" data-open-signup role="listitem" aria-label="Mia, 25 — kostenlos registrieren und schreiben">
          <span class="pav"><img :src="img('mia')" alt="" decoding="async" width="72" height="72"></span>
          <span><span class="pnm">Mia, 25</span><span class="ptags"><span class="tag">Bücher</span><span class="tag">Kino</span></span></span>
        </button>
        <!-- Duplikat für Endlos-Schleife -->
        <span aria-hidden="true" style="display:contents">
          <button type="button" class="pcard is-on" data-open-signup tabindex="-1">
            <span class="pav"><img :src="img('lena')" alt="" decoding="async" width="72" height="72"><span class="dot"></span></span>
            <span><span class="pnm">Lena, 27</span><span class="ptags"><span class="tag">Fotografie</span><span class="tag">Wandern</span></span></span>
          </button>
          <button type="button" class="pcard" data-open-signup tabindex="-1">
            <span class="pav"><img :src="img('jonas')" alt="" decoding="async" width="72" height="72"><span class="dot"></span></span>
            <span><span class="pnm">Jonas, 29</span><span class="ptags"><span class="tag">Bouldern</span><span class="tag">Podcasts</span></span></span>
          </button>
          <button type="button" class="pcard is-on" data-open-signup tabindex="-1">
            <span class="pav"><img :src="img('carla')" alt="" decoding="async" width="72" height="72"><span class="dot"></span></span>
            <span><span class="pnm">Carla, 34</span><span class="ptags"><span class="tag">Yoga</span><span class="tag">Reisen</span></span></span>
          </button>
          <button type="button" class="pcard" data-open-signup tabindex="-1">
            <span class="pav"><img :src="img('anna')" alt="" decoding="async" width="72" height="72"></span>
            <span><span class="pnm">Anna, 54</span><span class="ptags"><span class="tag">Garten</span><span class="tag">Krimis</span></span></span>
          </button>
          <button type="button" class="pcard is-on" data-open-signup tabindex="-1">
            <span class="pav"><img :src="img('lukas')" alt="" decoding="async" width="72" height="72"><span class="dot"></span></span>
            <span><span class="pnm">Lukas, 27</span><span class="ptags"><span class="tag">Klettern</span><span class="tag">Filmabende</span></span></span>
          </button>
          <button type="button" class="pcard" data-open-signup tabindex="-1">
            <span class="pav"><img :src="img('mia')" alt="" decoding="async" width="72" height="72"></span>
            <span><span class="pnm">Mia, 25</span><span class="ptags"><span class="tag">Bücher</span><span class="tag">Kino</span></span></span>
          </button>
        </span>
      </div>
    </div>

    <div class="mq rev" role="list" aria-label="Weitere Mitglieder-Profile">
      <div class="mq-track">
        <!-- Reihe 2 -->
        <button type="button" class="pcard is-on" data-open-signup role="listitem" aria-label="Sophia, 27 — kostenlos registrieren und schreiben">
          <span class="pav"><img :src="img('sophia')" alt="" decoding="async" width="72" height="72"><span class="dot"></span></span>
          <span><span class="pnm">Sophia, 27</span><span class="ptags"><span class="tag">Tanzen</span><span class="tag">Städtetrips</span></span></span>
        </button>
        <button type="button" class="pcard" data-open-signup role="listitem" aria-label="Thomas, 48 — kostenlos registrieren und schreiben">
          <span class="pav"><img :src="img('thomas')" alt="" decoding="async" width="72" height="72"></span>
          <span><span class="pnm">Thomas, 48</span><span class="ptags"><span class="tag">Radtouren</span><span class="tag">Gitarre</span></span></span>
        </button>
        <button type="button" class="pcard is-on" data-open-signup role="listitem" aria-label="Mara, 32 — kostenlos registrieren und schreiben">
          <span class="pav"><img :src="img('mara')" alt="" decoding="async" width="72" height="72"><span class="dot"></span></span>
          <span><span class="pnm">Mara, 32</span><span class="ptags"><span class="tag">Fitness</span><span class="tag">Backen</span></span></span>
        </button>
        <button type="button" class="pcard" data-open-signup role="listitem" aria-label="Julia, 29 — kostenlos registrieren und schreiben">
          <span class="pav"><img :src="img('julia')" alt="" decoding="async" width="72" height="72"><span class="dot"></span></span>
          <span><span class="pnm">Julia, 29</span><span class="ptags"><span class="tag">Kochen</span><span class="tag">Serien</span></span></span>
        </button>
        <button type="button" class="pcard is-on" data-open-signup role="listitem" aria-label="Stephan, 35 — kostenlos registrieren und schreiben">
          <span class="pav"><img :src="img('stephan')" alt="" decoding="async" width="72" height="72"><span class="dot"></span></span>
          <span><span class="pnm">Stephan, 35</span><span class="ptags"><span class="tag">Grillen</span><span class="tag">Fußball</span></span></span>
        </button>
        <button type="button" class="pcard" data-open-signup role="listitem" aria-label="Laura, 38 — kostenlos registrieren und schreiben">
          <span class="pav"><img :src="img('laura')" alt="" decoding="async" width="72" height="72"></span>
          <span><span class="pnm">Laura, 38</span><span class="ptags"><span class="tag">Musik</span><span class="tag">Kaffee</span></span></span>
        </button>
        <!-- Duplikat für Endlos-Schleife -->
        <span aria-hidden="true" style="display:contents">
          <button type="button" class="pcard is-on" data-open-signup tabindex="-1">
            <span class="pav"><img :src="img('sophia')" alt="" decoding="async" width="72" height="72"><span class="dot"></span></span>
            <span><span class="pnm">Sophia, 27</span><span class="ptags"><span class="tag">Tanzen</span><span class="tag">Städtetrips</span></span></span>
          </button>
          <button type="button" class="pcard" data-open-signup tabindex="-1">
            <span class="pav"><img :src="img('thomas')" alt="" decoding="async" width="72" height="72"></span>
            <span><span class="pnm">Thomas, 48</span><span class="ptags"><span class="tag">Radtouren</span><span class="tag">Gitarre</span></span></span>
          </button>
          <button type="button" class="pcard is-on" data-open-signup tabindex="-1">
            <span class="pav"><img :src="img('mara')" alt="" decoding="async" width="72" height="72"><span class="dot"></span></span>
            <span><span class="pnm">Mara, 32</span><span class="ptags"><span class="tag">Fitness</span><span class="tag">Backen</span></span></span>
          </button>
          <button type="button" class="pcard" data-open-signup tabindex="-1">
            <span class="pav"><img :src="img('julia')" alt="" decoding="async" width="72" height="72"><span class="dot"></span></span>
            <span><span class="pnm">Julia, 29</span><span class="ptags"><span class="tag">Kochen</span><span class="tag">Serien</span></span></span>
          </button>
          <button type="button" class="pcard is-on" data-open-signup tabindex="-1">
            <span class="pav"><img :src="img('stephan')" alt="" decoding="async" width="72" height="72"><span class="dot"></span></span>
            <span><span class="pnm">Stephan, 35</span><span class="ptags"><span class="tag">Grillen</span><span class="tag">Fußball</span></span></span>
          </button>
          <button type="button" class="pcard" data-open-signup tabindex="-1">
            <span class="pav"><img :src="img('laura')" alt="" decoding="async" width="72" height="72"></span>
            <span><span class="pnm">Laura, 38</span><span class="ptags"><span class="tag">Musik</span><span class="tag">Kaffee</span></span></span>
          </button>
        </span>
      </div>
    </div>

    <div class="k-after">
      <p>Du möchtest jemandem hier schreiben? Erstell dein kostenloses Profil — dauert keine zwei Minuten.</p>
      <button type="button" class="btn-primary" data-open-signup>Kostenlos registrieren <span class="arrow">→</span></button>
    </div>
  </section>
</template>

<script>
import { profileImg } from './profiles';

export default {
  name: 'KennenlernenCommunitySection',
  methods: {
    img: profileImg,
  },
};
</script>
